import { api } from "@/api"

import type { MaybeRef } from "@vueuse/core"
import { useQuery } from "@tanstack/vue-query"

type ZReportFilter = {
  start?: string
  end?: string
  deviceId?: number
  search?: string
}

export type ZReportQuery = ZReportFilter & PaginationQuery

export type ListZReportsResponseItem = {
  id: string
  createdAt: Date
  deviceId: number
  deviceSerialNumber: string
  fromReceiptNo: string | null
  toReceiptNo: string | null
  totalCount: number | null
  totalAmount: number | null
}

const parseZReport = (
  zReport: RecursivelyConvertDatesToStrings<ListZReportsResponseItem>
): ListZReportsResponseItem => ({
  ...zReport,
  createdAt: DateFns.parseISO(zReport.createdAt),
})

export const listZReports = async (
  query?: ZReportQuery
): Promise<PaginatedResponse<ListZReportsResponseItem>> => {
  const {
    body: { items, ...body },
  } = await api.get<
    PaginatedResponse<
      RecursivelyConvertDatesToStrings<ListZReportsResponseItem>
    >
  >("/z-reports/", {
    query,
  })
  return {
    items: items.map(parseZReport),
    ...body,
  }
}

export const useZReports = (
  query?: MaybeRef<ZReportQuery>
) =>
  useQuery({
    queryKey: [BASE_Z_REPORTS_QUERY_KEY, query] as const,
    queryFn: ({ queryKey: [_, query_] }) =>
      listZReports(query_),
    refetchInterval: 60 * 1000,
  })
